export const catalogConfigs = {
  title: {
    default: "DAEYEE ENGINEERING E-catalog",
    ko: "대의엔지니어링 전자카탈로그",
  },
  langSet: ["ko", "en"],
  pageMap: [
    { name: "cover", outlets: ["scene1", "catalog-index"] },
    {
      name: "company",
      outlets: [
        "overview",
        "history",
        {
          name: "technology",
          outlets: ["1", "2"],
        },
      ],
    },
    {
      name: "solution",
      outlets: [
        {
          name: "formwork",
          outlets: [
            "overview",
            {
              name: "features",
              outlets: ["1", "2"],
            },
            "application-effect",
            {
              name: "compares",
              outlets: ["1", "2", "3"],
            },
            "item",
          ],
        },
        {
          name: "tableform-method",
          outlets: [
            "intro",
            "overview",
            "install-process",
            {
              name: "applications",
              outlets: ["rc-beam", "one-way", "post-tension", "tg-tp", "drop-panel"],
            },
            "work-process",
          ],
        },
        {
          name: "ms-method",
          outlets: [
            "intro",
            "overview",
            "install-process",
            {
              name: "applications",
              outlets: ["pit", "piloti", "refuge", "tg", "tp"],
            },
            "work-process",
          ],
        },
      ],
    },
    {
      name: "projects",
      outlets: [
        {
          name: "apt",
          outlets: ["1", "2", "3"],
        },
        {
          name: "industrial-center",
          outlets: ["1", "2", "3"],
        },
        {
          name: "data-center",
          outlets: ["1", "2", "3"],
        },
        {
          name: "building",
          outlets: ["1", "2", "3"],
        },
      ],
    },
    "last",
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 768,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
